import { useTheme } from '@pata-app/themes';
import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { testimonialOptions, Testimoninal } from '../../../../components/testimoninal/testimoninal';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';

const TestimoninalTitle = () => {
  return (
    <TextWithHighlight>
      <h2>
        Why <strong>canine hydrotherapists </strong>
        trust Pata booking software
      </h2>
    </TextWithHighlight>
  );
};

const TestimoninalSubTitle = () => {
  return (
    <p style={{ maxWidth: '850px' }}>
      We think our booking platform can make a world of difference, but don't just take our word for it. Here's why dog
      hydrotherapists love using Pata to manage bookings, reduce admin and grow their business.
    </p>
  );
};

export function HydrotherapyTestimoninal() {
  const theme = useTheme();

  const hydroTherapyTestimoninalConfig = [
    {
      children: testimonialOptions.canine_body_works,
      color: theme.core.colors.primary.blue.medium,
    },
  ];

  return (
    <WidthContainer noBackground>
      <SectionContainer title={TestimoninalTitle} subTitle={TestimoninalSubTitle}>
        <Testimoninal testimonialConfig={hydroTherapyTestimoninalConfig} />
      </SectionContainer>
    </WidthContainer>
  );
}
